import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, Leaf } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const marks = [
  { icon: ShieldCheck, title: "GST Registered", number: "07AOMPP2034B3Z7", note: "A fully compliant Indian enterprise" },
  { icon: BadgeCheck, title: "Trademark Registered", number: "No. 14867209", note: "The Laxwedeepan name, protected" },
  { icon: Leaf, title: "FSSAI Certified", number: "Lic. 23326002001289", note: "Food-grade purity in our ghee & oils", cert: "/assets/fssai-certificate.pdf" },
];

export const TrustStrip = () => (
  <section data-testid="trust-section" className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32">
    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="mb-16 text-center text-[11px] font-medium uppercase tracking-[0.4em] text-brand-ink/50"
    >
      Registered · Protected · Certified
    </motion.p>
    <div className="grid grid-cols-1 divide-y divide-brand-border border border-brand-border md:grid-cols-3 md:divide-x md:divide-y-0">
      {marks.map((m, i) => (
        <motion.div
          key={m.title}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
          className="group flex flex-col items-center gap-4 px-8 py-14 text-center transition-colors duration-500 hover:bg-brand-cream/50"
          data-testid={`trust-mark-${i + 1}`}
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-full border border-brand-gold/60 transition-colors duration-500 group-hover:bg-brand-gold/10">
            <m.icon className="h-6 w-6 text-brand-maroon" strokeWidth={1.25} />
          </span>
          <h3 className="font-display text-2xl font-medium text-brand-ink">{m.title}</h3>
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-brand-maroon" data-testid={`trust-number-${i + 1}`}>{m.number}</p>
          <p className="text-sm font-light text-brand-ink/60">{m.note}</p>
          {m.cert && (
            <a
              href={m.cert}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fssai-certificate-link"
              className="mt-1 inline-flex items-center gap-1.5 rounded-full border border-brand-gold/60 px-4 py-1.5 text-[10px] font-medium uppercase tracking-[0.2em] text-brand-maroon transition-colors duration-300 hover:bg-brand-gold hover:text-brand-ivory"
            >
              View Certificate
            </a>
          )}
        </motion.div>
      ))}
    </div>
  </section>
);
